import { c as _c } from "react/compiler-runtime";
import type { ItineraryCardContentProps } from './ItineraryCard.types';
import styles from './ItineraryCardContent.module.css';
export function ItineraryCardContent(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div data-test-id="ItineraryCardContent" className={styles.content}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}